import React, { useEffect, useRef, useState, useCallback } from 'react';
import ShowList from './ShowList';
import styles from './FavShowsContent.module.css';

import backIcon   from '../icons/back_icn.png';
import axios from 'axios';

const FavShowsContent = ({ onBack, isAuthenticated, sendEvent }) => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);

  const [likedShows, setLikedShows] = useState([]);

  const fetchLikedShows = useCallback(() => {
    if (isAuthenticated) {
      axios
        .get('/api/favorites/list')
        .then((response) => {
          setLikedShows(response.data || []);
        })
        .catch(() => {});
    } else {
      setLikedShows([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    fetchLikedShows();

    // Совместимость с текущим именем события из ShowItem
    const h1 = () => fetchLikedShows();
    const h2 = () => fetchLikedShows();

    window.addEventListener('likedBeatsChanged', h1);
    window.addEventListener('likedShowsChanged', h2);

    return () => {
      window.removeEventListener('likedBeatsChanged', h1);
      window.removeEventListener('likedShowsChanged', h2);
    };
  }, [isAuthenticated, fetchLikedShows]);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    let scrollStep = 1;

    const startAutoScroll = () => {
      scrollInterval.current = setInterval(() => {
        if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
          clearInterval(scrollInterval.current);
          scrollInterval.current = null;
        } else {
          content.scrollTop += scrollStep;
        }
      }, 50);
    };

    startAutoScroll();

    const stopAutoScroll = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stopAutoScroll, { passive: true });
      content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
    };

    content.addEventListener('wheel', stopAutoScroll, { passive: true });
    content.addEventListener('touchstart', stopAutoScroll, { passive: true });

    return () => {
      content.removeEventListener('wheel', stopAutoScroll, { passive: true });
      content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      clearInterval(scrollInterval.current);
    };
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    content.scrollTop = 0;
    let scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel', stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });
  };

  return (
    <div className={styles.favShowsContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />

      <h1 className={styles.pageTitle}>Улюблені Події</h1>

      <div className={styles.favShowsContent} ref={contentRef}>
        {likedShows.length > 0 ? (
          <>
            <ShowList
              propShows={likedShows}
              isAuthenticated={isAuthenticated}
              restartAutoScroll={restartAutoScroll}
              sendEvent={sendEvent}
            />
          </>
        ) : (
          <p className={styles.noFavoritesMessage}>
            {isAuthenticated
              ? 'Поки без лайків на шоу.'
              : 'Залогінься, щоб глянути улюблені!'}
          </p>
        )}
      </div>
    </div>
  );
};

export default FavShowsContent;

